import React, { Component } from 'react';
import Block from  './components/Block';

var oldSpecialties = [
  {
    old: true,
    VacancyName: 'Администратор на ресепшен',
    id: 'administrator-na-resepshen'
  },
  {
    old: true,
    VacancyName: 'Бригадир группы почтальонов',
    id: 'brigadir-gruppy-pochtalonov'
  },
  {
    old: true,
    VacancyName: 'Управление персоналом',
    id: 'upravlenie-personalom'
  },
  {
    old: true,
    VacancyName: 'Административный персонал',
    id: 'administrativnyj-personal'
  },
  {
    old: true,
    VacancyName: 'Верстальщик',
    id: 'verstalshhik'
  },
  {
    old: true,
    VacancyName: 'Воспитатель',
    id: 'vospitatel'
  },
  {
    old: true,
    VacancyName: 'Генеральный директор',
    id: 'generalnyj-direktor'
  },
  {
    old: true,
    VacancyName: 'Грузчик',
    id: 'gruzchik'
  },
  {
    old: true,
    VacancyName: 'Гувернантка',
    id: 'guvernantka'
  },
  {
    old: true,
    VacancyName: 'Дворник, Уборщик',
    id: 'dvornik-uborshhik'
  },
  {
    old: true,
    VacancyName: 'Домработник',
    id: 'domrabotnik'
  },
  {
    old: true,
    VacancyName: 'Контент менеджер',
    id: 'kontent-menedzher'
  },
  {
    old: true,
    VacancyName: 'Контролер',
    id: 'kontroler'
  },
  {
    old: true,
    VacancyName: 'Контроллер',
    id: 'kontroller'
  },
  {
    old: true,
    VacancyName: 'Курьер',
    id: 'kurer'
  },
  {
    old: true,
    VacancyName: 'Логист / Диспетчер',
    id: 'logist-dispetcher'
  },
  {
    old: true,
    VacancyName: 'Маляр',
    id: 'malyar'
  },
  {
    old: true,
    VacancyName: 'Мастер - отделочник',
    id: 'master-otdelochnik'
  },
  {
    old: true,
    VacancyName: 'Мастер по мелкому бытовому ремонту',
    id: 'master-po-melkomu-bytovomu-remontu'
  },
  {
    old: true,
    VacancyName: 'Мастер по ремонту ванных комнат, кухонь, квартир',
    id: 'master-po-remontu-vannyx-komnat-kuxon-kvartir'
  },
  {
    old: true,
    VacancyName: 'Менеджер группы инженеров в отдел по крупному бытовому ремонту',
    id: 'menedzher-gruppy-inzhenerov-v-otdel-po-krupnomu-bytovomu-remontu'
  },
  {
    old: true,
    VacancyName: 'Менеджер группы инженеров в отдел по мелкому бытовому ремонту',
    id: 'menedzher-gruppy-inzhenerov-v-otdel-po-melkomu-bytovomu-remontu'
  },
  {
    old: true,
    VacancyName: 'Менеджер группы инженеров в отдел по ремонту компьютерной техники',
    id: 'menedzher-gruppy-inzhenerov-v-otdel-po-remontu-kompyuternoj-texniki'
  },
  {
    old: true,
    VacancyName: 'Менеджер группы инженеров в отдел по ремонту стиральных машин',
    id: 'menedzher-gruppy-inzhenerov-v-otdel-po-remontu-stiralnyx-mashin'
  },
  {
    old: true,
    VacancyName: 'Менеджер группы инженеров в отдел по ремонту холодильного оборудования',
    id: 'menedzher-gruppy-inzhenerov-v-otdel-po-remontu-xolodilnogo-oborudovaniya'
  },
  {
    old: true,
    VacancyName: 'Менеджер по персоналу / Рекрутер',
    id: 'menedzher-po-personalu-rekruter'
  },
  {
    old: true,
    VacancyName: 'Менеджер по поиску и привлечению новых клиентов',
    id: 'menedzher-po-poisku-i-privlecheniyu-novyx-klientov'
  },
  {
    old: true,
    VacancyName: 'Менеджер по продажам рекламных услуг',
    id: 'menedzher-po-prodazham-reklamnyx-uslug'
  },
  {
    old: true,
    VacancyName: 'Менеджер по продажам IT услуг',
    id: 'menedzher-po-prodazham-it-uslug'
  },
  {
    old: true,
    VacancyName: 'Монтажник',
    id: 'montazhnik'
  },
  {
    old: true,
    VacancyName: 'Оператор Call-центра',
    id: 'operator-call-centra'
  },
  {
    old: true,
    VacancyName: 'Помощник специалиста по контестной рекламе',
    id: 'pomoshhnik-specialista-po-kontestnoj-reklame'
  },
  {
    old: true,
    VacancyName: 'Почтальон',
    id: 'pochtalon'
  },
  {
    old: true,
    VacancyName: 'Промоутер',
    id: 'promouter'
  },
  {
    old: true,
    VacancyName: 'Разнорабочий',
    id: 'raznorabochij'
  },
  {
    old: true,
    VacancyName: 'Расклейщик',
    id: 'rasklejshhik'
  },
  {
    old: true,
    VacancyName: 'Репетитор',
    id: 'repetitor'
  },
  {
    old: true,
    VacancyName: 'Руководитель отдела продаж',
    id: 'rukovoditel-otdela-prodazh'
  },
  {
    old: true,
    VacancyName: 'Руководитель сервисного центра',
    id: 'rukovoditel-servisnogo-centra'
  },
  {
    old: true,
    VacancyName: 'Сантехник',
    id: 'santexnik'
  },
  {
    old: true,
    VacancyName: 'Сборщик мебели',
    id: 'sborshhik-mebeli'
  },
  {
    old: true,
    VacancyName: 'Сервисный инженер по (BGA) ремонту бытовой электроники',
    id: 'servisnyj-inzhener-po-bga-remontu-bytovoj-elektroniki'
  },
  {
    old: true,
    VacancyName: 'Сервисный инженер по (BGA) ремонту ноутбуков',
    id: 'servisnyj-inzhener-po-bga-remontu-noutbukov'
  },
  {
    old: true,
    VacancyName: 'Сервисный инженер по ремонту персональных компьютеров',
    id: 'servisnyj-inzhener-po-remontu-personalnyx-kompyuterov'
  },
  {
    old: true,
    VacancyName: 'Сервисный инженер по ремонту принтеров',
    id: 'servisnyj-inzhener-po-remontu-printerov'
  },
  {
    old: true,
    VacancyName: 'Сервисный инженер по ремонту смартфонов',
    id: 'servisnyj-inzhener-po-remontu-smartfonov'
  },
  {
    old: true,
    VacancyName: 'Сервисный инженер по ремонту стиральных машин',
    id: 'servisnyj-inzhener-po-remontu-stiralnyx-mashin'
  },
  {
    old: true,
    VacancyName: 'Сервисный инженер по ремонту холодильного оборудования',
    id: 'servisnyj-inzhener-po-remontu-xolodilnogo-oborudovaniya'
  },
  {
    old: true,
    VacancyName: 'Сиделка',
    id: 'sidelka'
  },
  {
    old: true,
    VacancyName: 'Системный администратор',
    id: 'sistemnyj-administrator'
  },
  {
    old: true,
    VacancyName: 'Специалист по маркетингу в интернете',
    id: 'specialist-po-marketingu-v-internete'
  },
  {
    old: true,
    VacancyName: 'Ученик по ремонту стиральных и посудомоечных машин',
    id: 'uchenik-po-remontu-stiralnyx-i-posudomoechnyx-mashin'
  },
  {
    old: true,
    VacancyName: 'Электрик',
    id: 'elektrik'
  },
  {
    old: true,
    VacancyName: 'Электромонтер, Кабельщик',
    id: 'elektromonter-kabelshhik'
  },
  {
    old: true,
    VacancyName: 'Юрист',
    id: 'yurist'
  },
  {
    old: true,
    VacancyName: 'Web дизайнер',
    id: 'web-dizajner'
  }
]


var SelectSpecialties = React.createClass({
  getInitialState: function(){
    return({specialties: this.props.specialties})
  },
  // componentWillReceiveProps: function(nextProps) {
  //   this.setState({specialties: nextProps.specialties});
  // },
  getListActiveSpecialties: function(){
    var activeSpecialties = [];
    for(var i = 0, l = this.state.specialties.length; i < l; i++){
      if(this.state.specialties[i].active){
        var specialty = this.state.specialties[i];
        delete specialty.test;
        delete specialty.updatedAt;
        delete specialty.createdAt;
        // delete specialty.VacancyID;
        delete specialty.DepartmentID;
        activeSpecialties[activeSpecialties.length] = specialty;
      }
    }
    console.log('activeSpecialties', activeSpecialties)
    return activeSpecialties;
  },
  handlerAddSpecialty: function(id, status){
    var specialties = [ ...this.state.specialties ];
      var specialty = id;
      if(!specialty.active){
        specialty.active = true;
        specialties.push(specialty);
        
      }else{
        specialty.active = false;
        for(var item of specialties){
          if(item.id == specialty.id){
            item.active = false;
          }
        }
      }
      
      console.log('specialties', specialties)

    this.setState({specialties: specialties});
  },
  openOrClose: function(){
    this.props.saveSpecialties(this.getListActiveSpecialties());
    this.setState({open: !this.state.open})
  },
  render: function(){
    if(this.state.open){
      return(
        <div className="Specialties" style={{width: '80%'}}>
          <div onClick={this.openOrClose} className="SelectSpecialtiesOpen" style={{marginTop: 15}}>Сохранить</div>
          {this.props.listSpecialties.map((specialty, i) => {
            var active = false;
            this.state.specialties.forEach(element => {
              if(element.id == specialty.id && element.active){
                active = true;
                specialty.active = true;
              }
            });
            if(!specialty.old){
              return(
                <Block key={i} id={i} specialty={specialty} active={active} addSpecialty={this.handlerAddSpecialty}>{specialty.VacancyName}</Block>
              );
            }
            
          })}
          <div className="headlineWrapper">
            <div className="headline">Старые специальности</div>
          </div>
          {oldSpecialties.map((specialty, i) => {
            var active = false;
            this.state.specialties.forEach(element => {
              if(element.id == specialty.id && element.active){
                active = true;
                specialty.active = true;
              }
            });
            return(
              <Block key={i} id={i} active={active} specialty={specialty} addSpecialty={this.handlerAddSpecialty}>{specialty.VacancyName}</Block>
            );
          })}
        </div>
      );
    }else{
      return(
        <div onClick={this.openOrClose} className="SelectSpecialtiesOpen">Доступные специальности ({this.props.specialties.length})</div>
      );
    }
  }
});

export default SelectSpecialties;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanel/components/SelectSpecialties/index.jsx
 **/